export const removeTimeFromDate = (date: Date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate());
